import React from 'react';

const QuickViewQuotes = ({quoteData}) => {
  if (!quoteData || Object.keys(quoteData).length === 0) {
    return null;
  }

  return Object.entries(quoteData)
    .map(([quantity, price]) => {
      const priceNum = parseFloat(price);
      const priceUsd = Number.isNaN(priceNum)
        ? ''
        : priceNum.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency'
          });
      return {
        quantity: parseInt(quantity, 10),
        quote: `${priceUsd} @ ${quantity} each`
      };
    })
    .sort((a, b) => a.quantity - b.quantity)
    .map((quote) => <div key={quote.quantity}>{quote.quote}</div>);
};

export default QuickViewQuotes;
